<div class="subheader with-padding flgrow" style="position: relative">
  <div class="row align-items-center">
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8 maxw600">
      <div class="d-flex">
        <div class="flex-grow-1">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
              [(ngModel)]="requestModel.searchTerm" autocomplete="off" (keyup.enter)="onQuickSearch()" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary" (click)="onQuickSearch()">
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div>
        </div>
        <div class="ml-2 advanced-search-box">
          <button (click)="onAdvSearch()" class="btn btn-primary" aria-label="Center Align">
            <i class="fa fa-search-plus" aria-hidden="true"></i>
          </button>
          <div class="searchbox card fix lt width600px" *ngIf="isShowAdvanced">
            <div class="row mt-3">
              <div class="col-6">
                <label translate>lblName</label>
                <input name="requestModel.name" #name="ngModel" [(ngModel)]="requestModel.name" type="text"
                  class="form-control">
              </div>
              <div class="col-6">
                <label translate>lblSubject</label>
                <input name="requestModel.subject" [(ngModel)]="requestModel.subject" type="text" class="form-control">
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6">
                <label translate>lblEvent</label>
                <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblSelectEvent' | translate }}"
                  [(ngModel)]="requestModel.actionCode">
                  <ng-option *ngFor="let action of actionTypeList" [value]="action.actionCode" translate>
                    {{action.actionLabelKey}}</ng-option>
                </ng-select>
              </div>
              <div class="col-6">
                <label translate>lblDealer</label>
                <app-dealer-searchbox-dropdown [dealerList]="dealerList" [ngModel]="requestModel.dealerId"
                  [selectedDealer]="requestModel.dealerId" ngDefaultControl name="requestModel.dealerId"
                  (onSelectDealer)="onDealerSelected($event, false)">
                </app-dealer-searchbox-dropdown>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6">
                <label translate>lblChannel</label>
                <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblSelectChannelName' | translate }}"
                  [(ngModel)]="requestModel.templateType">
                  <ng-option *ngFor="let typ of templateTypeList" [value]="typ.value">
                    {{typ.text}}</ng-option>
                </ng-select>
              </div>
              <div class="col-6">
                <label translate>lblSection</label>
                <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblSelectSection' | translate }}"
                  [(ngModel)]="requestModel.applicationId">
                  <ng-option *ngFor="let module of moduleList" [value]="module.id">
                    {{module.name}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6">
                <label translate>lblUserType</label>
                <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblSelectUserType' | translate }}"
                  [(ngModel)]="requestModel.userTypeId">
                  <ng-option *ngFor="let user of userTypeList" [value]="user.id">
                    {{user.name}}</ng-option>
                </ng-select>
              </div>
              <div class="col-6">
                <label translate>lblTemplateUsage</label>
                <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblSelectTemplateUsage' | translate }}"
                  [(ngModel)]="requestModel.templateUsageId">
                  <ng-option *ngFor="let templateUsage of templateUsageList" [value]="templateUsage.id">
                    {{templateUsage.name}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6">
                <label translate>lblStatus</label>
                <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblStatus' | translate }}"
                  [(ngModel)]="requestModel.statusId">
                  <ng-option *ngFor="let status of statusList" [value]="status.id">
                    {{status.value}}</ng-option>
                </ng-select>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col text-right">
                <button type="button" (click)="AdvanceSearchSubmit()" aria-label="Center Align"
                  class="btn btn-primary mr-sm-2" translate>lblApply
                </button>
                <button type="button" (click)="onReset()" aria-label="Center Align"
                  class="btn btn-outline-tertiary mr-sm-2" translate>lblReset
                </button>
                <button type="button" (click)="onAdvSearchCancel()" aria-label="Center Align"
                  class="btn btn-outline-tertiary mr-sm-2" translate>lblClose
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-2 pl-2">
      <app-dealer-searchbox-dropdown [dealerList]="dealerList" [ngModel]="requestModel.dealerId"
        [selectedDealer]="requestModel.dealerId" ngDefaultControl name="requestModel.dealerId"
        (onSelectDealer)="onDealerSelected($event, true)">
      </app-dealer-searchbox-dropdown>
    </div>
    <div class="col-2 pl-0">
      <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblSelectChannelName' | translate }}"
        [(ngModel)]="requestModel.templateType" (change)="onQuickSearch()">
        <ng-option *ngFor="let templateItem of templateTypeList" [value]="templateItem.value">
          {{templateItem.text}}</ng-option>
      </ng-select>
    </div>
    <div class="col-2 pl-0">
      <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblSelectTemplateUsage' | translate }}"
        [(ngModel)]="requestModel.templateUsageId" (change)="onQuickSearch()">
        <ng-option *ngFor="let templateUsage of templateUsageList" [value]="templateUsage.id">
          {{templateUsage.name}}</ng-option>
      </ng-select>
    </div>
    <div class="col pl-0">
      <button type="button" (click)="onReset()" class="btn btn-primary btn-md"
        ngbTooltip="{{'lblClearFilters' | translate }}" placement="bottom" aria-label="Center Align"><em
          class="far fa-times-circle font16 align-top"></em></button>
      <button type="button" (click)="onQuickSearch()" class="ml-2 btn btn-outline-primary" placement="bottom"
        aria-label="Center Align"><em class="fas fa-sync fa-lg"></em></button>
    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" (click)="onAdd()" aria-label="Center Align" type="reset" class="add-button btn btn-primary"
        translate>lblAddTemplate</button>
    </div>
  </div>
</div>
<div class="container prel pos">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex justify-content-between" translate>
          lblMessageTemplates
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
            totalCount
            }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>
        <div class="table-responsive  max-h232" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th scope="col" style="width: 55px" translate>#</th>
                <th scope="col" sortable="DealerName" (sort)="onSort($event)" translate>lblDealer</th>
                <th scope="col" sortable="ActionName" (sort)="onSort($event)" translate>lblEventName</th>
                <th scope="col" sortable="Name" (sort)="onSort($event)" translate>lblName</th>
                <th scope="col" sortable="Subject" (sort)="onSort($event)" translate>lblSubject</th>
                <th scope="col" sortable="TemplateType" (sort)="onSort($event)" translate>lblChannel</th>
                <th scope="col" sortable="ApplicationId" (sort)="onSort($event)" translate>lblSection</th>
                <th scope="col" sortable="UserTypeId" (sort)="onSort($event)" translate>lblUserType</th>
                <th scope="col" sortable="TemplateUsageId" (sort)="onSort($event)" translate>lblTemplateUsage</th>
                <th style="width: 5%" class="text-center" scope="col" sortable="IsActive" (sort)="onSort($event)"
                  translate>lblActive</th>
                <th scope="col" style="width: 120px" class="text-center" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="templateList?.length>0; else load_NotFound_Template">
                <tr *ngFor="let template of templateList; let i=index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <ngb-highlight *ngIf="template.dealerName!=null;else AllDealer" [result]="template.dealerName">
                    </ngb-highlight>
                    <ng-template #AllDealer>
                      <div *ngIf="template.dealerId==='-1'" translate>
                        lblAllDealer
                      </div>
                    </ng-template>
                  </td>
                  <td translate>
                    {{template.actionLabelKey}}
                  </td>
                  <td><ngb-highlight [result]="template.name"></ngb-highlight></td>
                  <td><ngb-highlight [result]="template.subject"></ngb-highlight></td>
                  <td><ngb-highlight [result]="channelType[template.templateType]"></ngb-highlight></td>
                  <td><ngb-highlight [result]="template.applicationName"></ngb-highlight></td>
                  <td><ngb-highlight [result]="template.userTypeName"></ngb-highlight></td>
                  <td><ngb-highlight [result]="template.templateUsageName"></ngb-highlight></td>
                  <td class="text-center">
                    <em class="fas" [ngClass]="{'fa-check': template.isActive, 'fa-times': !template.isActive}"></em>
                  </td>
                  <td class="nowrap text-center">
                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                      (click)="onEdit(template.templateId)" *ngIf="userRoleRightsDetails.canEdit">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_NotFound_Template>
                <tr>
                  <td colspan="11" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>